import { differenceInYears, isValid } from 'date-fns';

import { ensureDate } from 'helpers';

export const checkNoErrors = (errors: Array<Record<string, boolean>>) => {
  return errors
    ? errors.every((error) => Object.values(error).every((v) => v === false))
    : true;
};
export const setDateErrors = (
  start: Date | string | null,
  end: Date | string | null,
) => {
  const dateErrors = {
    dateOrderError: false,
    dateDiffError: false,
    dateCompleteError: false,
    startDateFormatError: false,
    endDateFormatError: false,
  };
  if (start && typeof start !== 'string' && !isValid(start)) {
    dateErrors.startDateFormatError = true;
  }
  if (end && typeof end !== 'string' && !isValid(end)) {
    dateErrors.endDateFormatError = true;
  }
  if (start && end) {
    const startDate = ensureDate(start);
    const endDate = ensureDate(end);
    if (endDate < startDate) {
      dateErrors.dateOrderError = true;
    }
    if (differenceInYears(endDate, startDate) > 100) {
      dateErrors.dateDiffError = true;
    }
  } else {
    dateErrors.dateCompleteError = true;
  }
  return dateErrors;
};

export const wasNotEmployed = (review_status: string) => {
  return ['did_not_work_insufficient_info', 'did_not_work_certain'].includes(
    review_status,
  );
};

export const validateEmail = (email: string | null) => {
  if (!email) {
    return false;
  }

  const matches = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  return !!matches;
};
